var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100 outer"},[_c('div',{staticClass:"h-100 m-0 p-0 d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"auth-container text-center"},[_c('strong',[_vm._v("Please Select Account to Manage:")]),_c('TeamSelect')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }